import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  reviewStatus: "Review status",
  reviewStatusDescription: "Completed advice by compliance check",
  notReviewed: "Not reviewed",
  flagged: "Flagged",
  approved: "Approved",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    reviewStatus: "Statut de revue",
    reviewStatusDescription: "Conseils terminés selon le contrôle de conformité",
    notReviewed: "Non revu",
    flagged: "Signalé",
    approved: "Approuvé",
  },
  es_ES: {
    reviewStatus: "Estado de revisión",
    reviewStatusDescription: "Asesoramientos completados según el control de cumplimiento",
    notReviewed: "Sin revisar",
    flagged: "Marcado",
    approved: "Aprobado",
  },
  pt_BR: {
    reviewStatus: "Status da revisão",
    reviewStatusDescription: "Recomendações concluídas por verificação de compliance",
    notReviewed: "Não revisado",
    flagged: "Sinalizado",
    approved: "Aprovado",
  },
  de_DE: {
    reviewStatus: "Prüfstatus",
    reviewStatusDescription: "Abgeschlossene Beratungen nach Compliance-Prüfung",
    notReviewed: "Nicht geprüft",
    flagged: "Markiert",
    approved: "Freigegeben",
  },
  it_IT: {
    reviewStatus: "Stato di revisione",
    reviewStatusDescription: "Consulenze completate per controllo di compliance",
    notReviewed: "Non revisionato",
    flagged: "Segnalato",
    approved: "Approvato",
  },
  ar: {
    reviewStatus: "حالة المراجعة",
    reviewStatusDescription: "الاستشارات المكتملة حسب فحص الامتثال",
    notReviewed: "لم تتم مراجعتها",
    flagged: "مُعلَّمة",
    approved: "معتمدة",
  },
  ja_JP: {
    reviewStatus: "レビュー状況",
    reviewStatusDescription: "コンプライアンスチェック別の完了済みアドバイス",
    notReviewed: "未レビュー",
    flagged: "要確認",
    approved: "承認済み",
  },
  hi_IN: {
    reviewStatus: "समीक्षा स्थिति",
    reviewStatusDescription: "अनुपालन जाँच के अनुसार पूर्ण सलाह",
    notReviewed: "समीक्षा नहीं हुई",
    flagged: "फ़्लैग किया गया",
    approved: "अनुमोदित",
  },
  zh_CN: {
    reviewStatus: "审核状态",
    reviewStatusDescription: "按合规检查划分的已完成建议",
    notReviewed: "未审核",
    flagged: "已标记",
    approved: "已批准",
  },
  zh_TW: {
    reviewStatus: "審核狀態",
    reviewStatusDescription: "依合規檢查區分的已完成建議",
    notReviewed: "未審核",
    flagged: "已標記",
    approved: "已核准",
  },
  nl_NL: {
    reviewStatus: "Beoordelingsstatus",
    reviewStatusDescription: "Voltooid advies per compliancecontrole",
    notReviewed: "Niet beoordeeld",
    flagged: "Gemarkeerd",
    approved: "Goedgekeurd",
  },
  nb_NO: {
    reviewStatus: "Gjennomgangsstatus",
    reviewStatusDescription: "Fullførte råd etter compliance-kontroll",
    notReviewed: "Ikke gjennomgått",
    flagged: "Flagget",
    approved: "Godkjent",
  },
  sv_SE: {
    reviewStatus: "Granskningsstatus",
    reviewStatusDescription: "Slutförd rådgivning efter compliance-kontroll",
    notReviewed: "Ej granskad",
    flagged: "Flaggad",
    approved: "Godkänd",
  },
  fi_FI: {
    reviewStatus: "Tarkastuksen tila",
    reviewStatusDescription: "Valmis neuvonta compliance-tarkastuksen mukaan",
    notReviewed: "Ei tarkastettu",
    flagged: "Merkitty",
    approved: "Hyväksytty",
  },
  da_DK: {
    reviewStatus: "Gennemgangsstatus",
    reviewStatusDescription: "Gennemført rådgivning efter compliance-kontrol",
    notReviewed: "Ikke gennemgået",
    flagged: "Markeret",
    approved: "Godkendt",
  },
  is_IS: {
    reviewStatus: "Staða yfirferðar",
    reviewStatusDescription: "Lokin ráðgjöf eftir regluvörsluathugun",
    notReviewed: "Ekki yfirfarið",
    flagged: "Flaggað",
    approved: "Samþykkt",
  },
};
